var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSegmentsBannerRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 141,
    viewBox: "0 0 243 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.178 49.9126C188.809 51.2677 196.357 53.6084 203.653 56.9961C207.091 58.5975 210.487 60.3839 213.842 62.4166C217.196 64.4492 223.151 69.0688 219.838 75.5981C217.993 79.2321 214.89 81.9424 212.501 84.6526C209.984 87.5475 207.427 90.4425 205.079 93.6455C201.892 98.0806 195.77 106.889 198.076 114.157C199.209 117.668 201.976 118.777 204.407 119.269C208.643 120.132 212.961 120.44 217.238 120.994C218.034 121.117 218.034 119.269 217.238 119.146C213.297 118.592 209.313 118.161 205.372 117.545C203.736 117.298 201.934 116.929 200.55 115.512C198.411 113.295 198.746 109.414 199.795 106.334C202.688 97.8341 208.39 91.6746 213.339 86.0077C216.86 82.0041 223.989 76.4604 221.474 68.5145C220.258 64.634 217.616 62.7246 215.058 61.1847C211.913 59.2136 208.726 57.4889 205.497 55.9491C197.615 52.13 189.438 49.5431 181.22 48.0647C180.382 47.9417 180.382 49.7896 181.178 49.9126Z",
    fill: "#232457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.061 23.0606V67.1747C128.061 68.3535 129.071 68.3535 129.071 67.1747V23.0606C129.071 21.8817 128.061 21.8817 128.061 23.0606Z",
    fill: "#232457"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.668 24.5294C143.078 24.0973 157.488 23.6652 171.898 23.1609C172.707 23.1609 172.707 21 171.898 21C157.488 21.4324 143.078 21.8645 128.668 22.3686C127.858 22.3686 127.858 24.5294 128.668 24.5294Z",
    fill: "#232457"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.495 21.8706V58.9531C171.495 60.1137 172.505 60.1137 172.505 58.9531V21.8706C172.505 20.7098 171.495 20.7098 171.495 21.8706Z",
    fill: "#232457"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.673 66.8823H165.832C166.648 66.8823 166.648 65.7059 165.832 65.7059H128.673C127.857 65.7059 127.857 66.8823 128.673 66.8823Z",
    fill: "#232457"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.58 67.3201C167.655 71.2682 170.503 74.0013 173.758 75.0947C174.531 75.3376 174.856 73.5763 174.084 73.3332C170.991 72.3007 168.388 69.7497 166.434 66.0448C165.946 65.0729 165.092 66.4092 165.58 67.3201Z",
    fill: "#232457"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.495 59.8278C171.12 64.6475 172.368 69.2167 174.194 73.4731C174.675 74.5371 175.876 73.5983 175.443 72.5343C173.617 68.4031 172.465 64.0215 171.888 59.3271C171.745 58.1378 170.352 58.6385 170.495 59.8278Z",
    fill: "#232457"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.74 36.2941H162.795C163.621 36.2941 163.621 33.9412 162.795 33.9412H134.74C133.915 33.9412 133.915 36.2941 134.74 36.2941Z",
    fill: "#232457"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.72 42.1765H160.805C161.59 42.1765 161.59 39.8235 160.805 39.8235H135.72C134.935 39.8235 134.935 42.1765 135.72 42.1765Z",
    fill: "#232457"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.738 46.8824H160.786C161.596 46.8824 161.596 44.5294 160.786 44.5294H135.738C134.929 44.5294 134.929 46.8824 135.738 46.8824Z",
    fill: "#232457"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2049 74.8225C47.2016 68.4293 51.158 61.9721 55.1535 55.579C55.7135 54.6839 54.8338 53.3413 54.3154 54.2363C50.3187 60.6295 46.3623 67.0867 42.3656 73.48C41.8459 74.375 42.6852 75.7175 43.2049 74.8225Z",
    fill: "#232457"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9204 55.9746C62.595 56.7853 70.2259 58.407 77.775 60.9745C78.5713 61.2446 78.9067 59.2854 78.1104 59.015C70.4781 56.4475 62.7204 54.7583 54.9204 53.9476C54.1242 53.8124 54.1242 55.8394 54.9204 55.9746Z",
    fill: "#232457"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6386 75.5854C49.9638 77.3863 58.289 79.1869 66.6568 80.9878C67.4605 81.1566 67.7986 79.5245 66.9948 79.3557C58.6696 77.5551 50.3444 75.7542 41.9766 73.9534C41.2168 73.7846 40.8362 75.4166 41.6386 75.5854Z",
    fill: "#232457"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6337 79.4595C71.9158 73.3089 75.1584 67.2168 78.4405 61.0661C78.9267 60.1875 77.8726 59.3088 77.3865 60.1876C74.1043 66.3382 70.8618 72.4303 67.5797 78.581C67.0935 79.4595 68.1475 80.3383 68.6337 79.4595Z",
    fill: "#232457"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4629 80.9502C68.4301 89.7901 69.3974 98.5703 70.3646 107.41C70.4804 108.545 71.6023 108.067 71.4866 106.932C70.5193 98.0924 69.5521 89.3122 68.5848 80.4724C68.4691 79.3377 67.3472 79.8154 67.4629 80.9502Z",
    fill: "#232457"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.717 108.75C74.5818 100.424 77.8046 92.4041 81.4772 84.69C81.9692 83.7104 80.8047 82.7922 80.3127 83.7718C76.6415 91.4856 73.3736 99.5058 70.5525 107.832C70.1944 108.873 71.3575 109.852 71.717 108.75Z",
    fill: "#232457"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.565 60.9751C78.5808 68.6054 79.5126 76.2359 80.3591 83.8662C80.4857 85.0261 81.7134 84.5377 81.5868 83.3779C80.783 75.6864 79.8512 68.0561 78.7927 60.4867C78.6234 59.3269 77.4384 59.8153 77.565 60.9751Z",
    fill: "#232457"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2193 75.0929C43.0204 84.1901 44.5855 93.4093 45.8668 102.69C46.0087 103.85 47.3841 103.361 47.2423 102.201C45.9609 92.9209 44.3958 83.7626 42.5948 74.6045C42.3573 73.4444 40.9819 73.9329 41.2193 75.0929Z",
    fill: "#232457"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7011 104.038C53.8633 107.66 62.3288 109.409 70.8799 109.222C71.6999 109.222 71.6999 107.348 70.8799 107.348C62.458 107.535 54.1231 105.849 46.0466 102.227C45.2265 101.853 44.8811 103.664 45.7011 104.038Z",
    fill: "#232457"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0236 83.5672C30.6256 87.3419 22.4964 79.599 22.019 67.5336C21.5265 54.4035 30.7222 45.7077 37.5339 40.727C54.1427 28.65 71.9701 35.6575 89.4687 39.2319C99.0899 41.2239 108.975 41.8563 118.142 36.5971C118.871 36.1788 119.331 37.9271 118.601 38.3455C104.634 46.3586 89.5379 41.0035 75.1607 37.7166C67.6427 35.9943 59.9702 34.6952 52.3896 36.0937C43.213 37.8042 33.5581 43.7455 27.0701 53.8386C23.5689 59.3345 22.0539 66.8429 24.4902 74.0962C26.9112 81.2912 32.6871 84.2815 37.5602 81.821C38.2893 81.4029 38.7871 83.1292 38.0197 83.5693L38.0236 83.5672Z",
    fill: "#232457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentsBannerRight);
export default __webpack_public_path__ + "static/media/segmentsBannerRight.92bb3957ae46b4b35a37be07dcecef43.svg";
export { ForwardRef as ReactComponent };